function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import hasInterface from '../../../../hasInterface';
import Coordinate from '../geom/Coordinate';
import CoordinateSequence from '../geom/CoordinateSequence';
var Area = /*#__PURE__*/function () {
  function Area() {
    _classCallCheck(this, Area);
    Area.constructor_.apply(this, arguments);
  }
  return _createClass(Area, [{
    key: "getClass",
    value: function getClass() {
      return Area;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "ofRing",
    value: function ofRing() {
      if (arguments[0] instanceof Array) {
        var ring = arguments[0];
        return Math.abs(Area.ofRingSigned(ring));
      } else if (hasInterface(arguments[0], CoordinateSequence)) {
        var _ring = arguments[0];
        return Math.abs(Area.ofRingSigned(_ring));
      }
    }
  }, {
    key: "ofRingSigned",
    value: function ofRingSigned() {
      if (arguments[0] instanceof Array) {
        var ring = arguments[0];
        if (ring.length < 3) return 0.0;
        var sum = 0.0;
        var x0 = ring[0].x;
        for (var i = 1; i < ring.length - 1; i++) {
          var x = ring[i].x - x0;
          var y1 = ring[i + 1].y;
          var y2 = ring[i - 1].y;
          sum += x * (y2 - y1);
        }
        return sum / 2.0;
      } else if (hasInterface(arguments[0], CoordinateSequence)) {
        var _ring2 = arguments[0];
        var n = _ring2.size();
        if (n < 3) return 0.0;
        var p0 = new Coordinate();
        var p1 = new Coordinate();
        var p2 = new Coordinate();
        _ring2.getCoordinate(0, p1);
        _ring2.getCoordinate(1, p2);
        var _x = p1.x;
        p2.x -= _x;
        var _sum = 0.0;
        for (var _i = 1; _i < n - 1; _i++) {
          p0.y = p1.y;
          p1.x = p2.x;
          p1.y = p2.y;
          _ring2.getCoordinate(_i + 1, p2);
          p2.x -= _x;
          _sum += p1.x * (p0.y - p2.y);
        }
        return _sum / 2.0;
      }
    }
  }]);
}();
export { Area as default };
Area.constructor_ = function () {};